import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export const fadeUp = {
  hidden: { opacity: 0, y: 32 },
  show: { opacity: 1, y: 0, transition: { duration: 0.8, ease: EASE } },
};

export const fadeIn = {
  hidden: { opacity: 0 },
  show: { opacity: 1, transition: { duration: 0.9, ease: EASE } },
};

export const stagger = (delay = 0, step = 0.12) => ({
  hidden: {},
  show: { transition: { staggerChildren: step, delayChildren: delay } },
});

/* Scroll-into-view reveal wrapper (y-axis only — RTL safe) */
export default function Reveal({ children, variants = fadeUp, className = "", style, ...rest }) {
  return (
    <motion.div
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, margin: "-80px" }}
      variants={variants}
      className={className}
      style={style}
      {...rest}
    >
      {children}
    </motion.div>
  );
}

/* Masked line-by-line headline reveal — the signature on-load moment */
export const MaskedLine = ({ children, delay = 0, className = "" }) => (
  <span className={`block overflow-hidden pb-[0.08em] ${className}`}>
    <motion.span
      className="block will-change-transform"
      initial={{ y: "112%" }}
      animate={{ y: "0%" }}
      transition={{ duration: 0.9, ease: EASE, delay }}
    >
      {children}
    </motion.span>
  </span>
);

/* Gentle perpetual float for hero chips / nodes */
export const Float = ({ children, delay = 0, distance = 10, duration = 5, className = "" }) => (
  <motion.div
    className={className}
    animate={{ y: [-distance / 2, distance / 2, -distance / 2] }}
    transition={{ duration, delay, repeat: Infinity, ease: "easeInOut" }}
  >
    {children}
  </motion.div>
);
